import React, { useEffect, useState } from 'react';
import { userService } from '../../service/user.service';

function Footer() {
    const [version, setVersion] = useState({});
    const versionInLocalStorage = localStorage.getItem('version');
    const appVersion = async () => {
        let stage = '';
        if (window.location.href.includes('dev')) {
            stage = 'develop';
        } else if (window.location.href.includes('staging')) {
            stage = 'staging';
        } else if (window.location.href.includes('beta')) {
            stage = 'beta';
        } else {
            stage = 'master';
        }
        const result = await userService.appVersion({
            stage,
        });
        localStorage.setItem('version', JSON.stringify(result.data.data[0].admin_web_application));
        setVersion(result.data.data[0].admin_web_application);
    };
    useEffect(() => {
        if (!versionInLocalStorage) { appVersion(); } else { setVersion(JSON.parse(versionInLocalStorage)); }
    }, []);
    return (
        <div className="text-center fixed bottom-0 w-full">
            <p className="text-xs3 font-semibold text-[#ED1C24] bg-[#ffffff] py-2">
                ©
                {'version : '}
                {version.latest_version}
                {', '}
                2022 Ador Welding Limited
            </p>
        </div>
    );
}

export default Footer;
